import { Component, Input, OnInit } from '@angular/core';
import { IRotatingWidget, IRotatingWidgetAnalytics } from '../../interfaces/interfaces';
import { WidgetAnalyticsOptions } from '../widgetanalyticsoptions';
import { AnalyticsService } from '../../services/analytics/analytics.service';

@Component({
  selector: 'rotating-widget',
  templateUrl: './rotating-widget.component.html'
})

export class GenericRotatingWidgetComponent implements OnInit, IRotatingWidgetAnalytics {
  _widget: IRotatingWidget;
  get widget(): IRotatingWidget {
    return this._widget;
  }

  @Input('widget')
  set widget(value: IRotatingWidget) {
    this._widget = value;
    this.selectedItem = Math.floor(Math.random() * this._widget.group.length);
    this.analytics_category = this.analyticsService.getRotatingWidgetCategory(this);
  }

  analytics_category: string;
  selectedItem: number;

  constructor(
    private analyticsService: AnalyticsService
  ) {
  }

  widget_analytics_type(): string {
    return WidgetAnalyticsOptions.promo;
  }

  analytics_title(): string {
    return this._widget.group[Number(this.selectedItem)].analytics_title;
  }

  ngOnInit(): void {
  }
}



// WEBPACK FOOTER //
// ./app/widgets/generic-rotating/rotating-widget.component.ts